// Bilingual route map — English + dedicated Spanish (/es/...) URLs for SEO.

export const ROUTES = {
  home: { en: '/', es: '/es' },
  walkin: { en: '/walk-in', es: '/es/atencion-sin-cita' },
  pi: { en: '/personal-injury', es: '/es/lesiones-personales' },
  services: { en: '/services', es: '/es/servicios' },
  programs: { en: '/programs', es: '/es/programas' },
  technology: { en: '/technology', es: '/es/tecnologia' },
  decompression: { en: '/decompression', es: '/es/descompresion' },
  contact: { en: '/contact', es: '/es/contacto' },
};

export const CONDITION_BASE = { en: '/conditions', es: '/es/tratamientos' };

export const pathFor = (key, lang = 'en') => (ROUTES[key] ? ROUTES[key][lang] : ROUTES.home[lang]);

export const conditionPath = (slug, lang = 'en') => `${CONDITION_BASE[lang]}/${slug}`;

export const isEsPath = (pathname) => pathname === '/es' || pathname.startsWith('/es/');

// Resolve a pathname to a { key, lang, slug? }
export const matchRoute = (pathname) => {
  for (const [key, val] of Object.entries(ROUTES)) {
    if (val.en === pathname) return { key, lang: 'en' };
    if (val.es === pathname) return { key, lang: 'es' };
  }
  if (pathname.startsWith(`${CONDITION_BASE.es}/`)) return { key: 'condition', lang: 'es', slug: pathname.split('/').pop() };
  if (pathname.startsWith(`${CONDITION_BASE.en}/`)) return { key: 'condition', lang: 'en', slug: pathname.split('/').pop() };
  return null;
};

// Given the current pathname, return the equivalent page in the target language.
export const altPath = (pathname, targetLang) => {
  const m = matchRoute(pathname);
  if (!m) return targetLang === 'es' ? '/es' : '/';
  if (m.key === 'condition') return conditionPath(m.slug, targetLang);
  return ROUTES[m.key][targetLang];
};

// Convert a hardcoded English path into the correct path for the active language.
export const localize = (enPath, lang = 'en') => {
  const entry = Object.entries(ROUTES).find(([, v]) => v.en === enPath);
  return entry ? entry[1][lang] : enPath;
};
